import StoreProvider from './redux/provider';
import AppRoutes from './routes/AppRoutes';
import StylesProvider from './styles/provider';
import './styles/table.css';

const App = () => {
  return (
    <StoreProvider>
      <StylesProvider>
        <AppRoutes />
      </StylesProvider>
    </StoreProvider>
  );
};

export default App;
